import React from 'react';
import {Separator} from '@spaced-out/ui-design-system/lib/components/Separator';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';

import css from './helper-components.css';


export const SeparatorWrapper = ({testId}: {testId?: string}) => {
  return (
    <div className={css.separatorWrapper}>
      <Separator
        width="1px"
        height="20px"
        orientation="vertical"
        testId={generateTestId({base: testId, slot: 'separator-wrapper'})}
      />
    </div>
  );
};
